const container = document.querySelectorAll('.o-ratio__content');
let length = (container.length == 1) ? 1 : 3;
let i = (length == 1) ? 0 : 1;

for (i; i < length; i++) {
        
    let addToCartDiv = document.createElement('div');
    addToCartDiv.className = 'custom-atc-button';

    let form = document.createElement('form');
    form.className = 'custom-atc-container';
    form.method = 'post';
    form.action = '/cart/add';

    let idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = meta.product.variants[0].id;

    let quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';

    let button = document.createElement('button');
    button.type = 'submit';
    button.name = 'add';
    button.className = 'custom-add-to-cart';

    form.appendChild(idInput);
    form.appendChild(quantityInput);
    form.appendChild(button);
    addToCartDiv.appendChild(form);

    container[i].appendChild(addToCartDiv);
}

const cartIcon = '<span class="icon icon--theme icon--quickbuy"><svg style="filter: brightness(0) saturate(100%);" width="16" height="16" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M27.5 43.5H5V14.4048H43V28.2611M34 14.1984V13.8105C34 8.66844 29.702 4.5 24.4 4.5H23.6C18.2981 4.5 14 8.66844 14 13.8105V14.1984M35 28.746V35.5349M35 35.5349V42.3238M35 35.5349H28M35 35.5349L42 35.5349" vector-effect="non-scaling-stroke"></path></svg></span>';
const cartIcon2 = '<span class="icon icon--theme icon--quickbuy icon--custom-add-to-cart"><svg style="filter: brightness(0) saturate(100%);" width="16" height="16" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M27.5 43.5H5V14.4048H43V28.2611M34 14.1984V13.8105C34 8.66844 29.702 4.5 24.4 4.5H23.6C18.2981 4.5 14 8.66844 14 13.8105V14.1984M35 28.746V35.5349M35 35.5349V42.3238M35 35.5349H28M35 35.5349L42 35.5349" vector-effect="non-scaling-stroke"></path></svg></span>';
let buttons = document.querySelectorAll('.custom-add-to-cart');

for (i=0; i < buttons.length; i++) {
            
    if (buttons.length==1) {

        buttons[i].innerHTML = cartIcon;
    }
    else {

        buttons[i].innerHTML = cartIcon2;
    }
}